// extracted by mini-css-extract-plugin
module.exports = {"container":"formEditUser_container__349QW","form":"formEditUser_form__3ORmC"};